import 'css-chunk:../../src/features/user-settings/components/settings-entry/index.module.scss';export default {
  "explanation": "_explanation_1b9h3_1",
  "label": "_label_1b9h3_5",
  "icon": "_icon_1b9h3_9"
};